import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  Only2PhotosInitModel,
  Only2PhotosInitVariables,
  Only2PhotosModel,
  Only2PhotosVariables,
} from '../../../../../models/email-template/only-2-photos.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-only-2-photos',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './only-2-photos.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './only-2-photos.component.scss'
})
export class Only2PhotosComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: Only2PhotosModel = new Only2PhotosInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new Only2PhotosInitVariables()
    }
  }

  //@ placeholders
  firstImagePlaceholder: string = 'First Image';
  secondImagePlaceholder: string = 'Second Image';
  firstImageHrefPlaceholder: string = 'Enter First Image Redirect Link';
  secondImageHrefPlaceholder: string = 'Enter Second Image Redirect Link';
  firstImageAltPlaceholder: string = 'Enter First Image Alt Text';
  secondImageAltPlaceholder: string = 'Enter Second Image Alt Text';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof Only2PhotosVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof Only2PhotosVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
